import React from "react";

const SocialMedia = () => {
  // Replace these with your actual last posts
  const instagramPosts = [
    {
      src: "assets/images/insta_1.jpg",
      link: "https://www.instagram.com/p/DUzbENnkopV/",
    },
    {
      src: "assets/images/insta_2.jpg",
      link: "https://www.instagram.com/p/DUpVvS5EpCB/?img_index=1",
    },
    {
      src: "assets/images/insta_3.jpg",
      link: "https://www.instagram.com/p/DUpVkhXkugW/?img_index=1",
    },

  ];

  const twitterPosts = [
    {
      src: "https://pbs.twimg.com/media/Fq653BRXwAIixC5?format=jpg&name=small",
      link: "https://x.com/Ccsumeerut",
    },
    {
      src: "https://pbs.twimg.com/media/Fq2_oW3X0AAaMV5?format=jpg&name=360x360",
      link: "https://x.com/Ccsumeerut",
    },
    {
      src: "https://pbs.twimg.com/media/Fz78tjmXsAAhKKj?format=jpg&name=small",
      link: "https://x.com/Ccsumeerut",
    },
    {
      src: "https://pbs.twimg.com/media/Fz7VTiYWwAYJjQW?format=jpg&name=small",
      link: "https://x.com/Ccsumeerut",
    },
  ];

  return (
    <div className="social py-5">
      <div className="overlay" />
      <div className="container main-box">
        <h1 className="my-heading" style={{ paddingLeft: 20, marginBottom: 20 }}>
          Follow us on Social Media
        </h1>

        <div className="boxes" style={{ display: "flex", gap: "20px" }}>

          {/* FACEBOOK */}
          <div className="box">
            <div className="top">
              <img src="assets/images/ccsu-logo-half.svg" alt="" />
              <div className="right">
                <h2>
                  Chaudhary Charan Singh
                  <br />
                  University, Meerut
                </h2>
              </div>
            </div>

            <a href="https://www.facebook.com/CCSUFB" target="_blank" rel="noopener noreferrer">
              <img src="assets/images/facebook.svg" className="center-logo" alt="Facebook" />
            </a>

            <div className="down">
              <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCCSUFB&tabs=timeline&width=416&height=296&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true"
                width="416"
                height="296"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen
                title="facebook"
              />
            </div>
          </div>

          {/* INSTAGRAM */}
          <div className="box">
            <div className="top">
              <img src="assets/images/ccsu-logo-half.svg" alt="" />
              <div className="right">
                <h2>
                  Chaudhary Charan Singh
                  <br />
                  University, Meerut
                </h2>
              </div>
            </div>

            <a href="https://www.instagram.com/ccsuinsta/" target="_blank" rel="noopener noreferrer">
              <img src="assets/images/instagram.svg" className="center-logo" alt="Instagram" />
            </a>

            <div
              className="down"
              style={{
                maxHeight: "400px",
                overflowY: "scroll",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {instagramPosts.map((post, index) => (
                <a key={index} href={post.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={post.src}
                    alt={`Instagram Post ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "8px",
                      borderBottom: "1px solid #000",
                    }}
                  />
                </a>
              ))}
            </div>
          </div>

          {/* TWITTER */}
          <div className="box">
            <div className="top">
              <img src="assets/images/ccsu-logo-half.svg" alt="" />
              <div className="right">
                <h2>
                  Chaudhary Charan Singh
                  <br />
                  University, Meerut
                </h2>
              </div>
            </div>

            <a href="https://twitter.com/ccsumeerut" target="_blank" rel="noopener noreferrer">
              <img
                src="assets/images/twitter.svg"
                className="center-logo"
                style={{ backgroundColor: "#000", padding: 7, borderRadius: 5 }}
                alt="Twitter"
              />
            </a>

            <div
              className="down"
              style={{
                maxHeight: "400px",
                overflowY: "scroll",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {twitterPosts.map((post, index) => (
                <a key={index} href={post.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={post.src}
                    alt={`Tweet ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "8px",
                      borderBottom: "1px solid #000",
                    }}
                  />
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SocialMedia;